"use strict";
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var Subject_1 = require("rxjs/Subject");
require("rxjs/add/operator/multicast");
require("rxjs/add/operator/finally");
// STOMP Connected Client Class
//
var ConnectedClient = /** @class */ (function () {
    function ConnectedClient(connection) {
        var _this = this;
        this.send = function (destination, body, headers) {
            if (body === void 0) { body = ''; }
            if (headers === void 0) { headers = { destination: destination }; }
            var headerToSend = __assign({}, headers, { destination: destination });
            _this.connection.messageSender.next(_this.connection.protocol.send(headerToSend, body));
        };
        this.begin = function (transaction) {
            _this.connection.messageSender.next(_this.connection.protocol.begin(transaction));
        };
        this.commit = function (transaction) {
            _this.connection.messageSender.next(_this.connection.protocol.commit(transaction));
        };
        this.abort = function (transaction) {
            _this.connection.messageSender.next(_this.connection.protocol.abort(transaction));
        };
        this.ack = function (messageID, subscription, headers) {
            _this.connection.messageSender.next(_this.connection.protocol.ack(messageID, subscription, headers));
        };
        // [NACK Frame](http://stomp.github.com/stomp-specification-1.1.html#NACK)
        this.nack = function (messageID, subscription, headers) {
            if (_this.connection.protocol.nack) {
                _this.connection.messageSender.next(_this.connection.protocol.nack(messageID, subscription, headers));
            }
            else {
                throw 'Nack unsupported operation';
            }
        };
        // [RECEIPT Frame](http://stomp.github.com/stomp-specification-1.1.html#RECEIPT)
        this.receipt = function () {
            // create one and only one broadcast receiver
            if (!_this.broadcastReceipterObservable) {
                var connectedSubscribe = _this.connection.messageReceipted
                    .finally(function () { return _this.broadcastReceipterObserver ? _this.broadcastReceipterObserver = null : null; })
                    .multicast(function () { return new Subject_1.Subject(); });
                connectedSubscribe.connect();
                _this.broadcastReceipterObservable = connectedSubscribe.refCount();
            }
            return _this.broadcastReceipterObservable;
        };
        // Return an Observable containing the event when a connection error occure
        this.connectionError = function () {
            // create one and only one broadcast receiver
            if (!_this.broadcastConnectionErrorObservable) {
                var connectionErrorSubscribe = _this.connection.errorReceived
                    .finally(function () { return _this.broadcastConnectionErrorObserver ? _this.broadcastConnectionErrorObserver = null : null; })
                    .multicast(function () { return new Subject_1.Subject(); });
                connectionErrorSubscribe.connect();
                _this.broadcastConnectionErrorObservable = connectionErrorSubscribe.refCount();
            }
            return _this.broadcastConnectionErrorObservable;
        };
        // Return an Observable containing the error when an error occure
        this.error = function () {
            // create one and only one broadcast receiver
            if (!_this.broadcastErrorObservable) {
                var connectedSubscribe = _this.connection.errorReceived
                    .finally(function () { return _this.broadcastErrorObserver ? _this.broadcastErrorObserver = null : null; })
                    .multicast(function () { return new Subject_1.Subject(); });
                connectedSubscribe.connect();
                _this.broadcastErrorObservable = connectedSubscribe.refCount();
            }
            return _this.broadcastErrorObservable;
        };
        // subscribe to a destination
        // return an Observable which you can unsubscribe
        this.subscribe = function (destination, headers) {
            if (headers === void 0) { headers = {}; }
            return _this.connection.subscribeTo(destination, headers);
        };
        // subscribe to a destination only once for multiple subscribers
        // return an Observable which you can unsubscribe
        this.subscribeBroadcast = function (destination, headers) {
            if (headers === void 0) { headers = {}; }
            // create one and only one dedicated observable per destination
            if (!_this.broadcastSubscribers[destination]) {
                var connectedSubscribe = _this.subscribe(destination, headers)
                    .finally(function () { return _this.broadcastSubscribers[destination] ? delete _this.broadcastSubscribers[destination] : null; })
                    .multicast(function () { return new Subject_1.Subject(); });
                connectedSubscribe.connect();
                _this.broadcastSubscribers[destination] = connectedSubscribe.refCount();
            }
            return _this.broadcastSubscribers[destination];
        };
        this.connection = connection;
        // subscription callbacks indexed by subscriber's ID
        this.broadcastSubscribers = {};
    }
    return ConnectedClient;
}());
exports.ConnectedClient = ConnectedClient;
